import { useEffect } from "react";
import { supabase } from "./lib/supabase";

type WpsRecord={
  id:string;
  document_number:string;
  title:string|null;
  document_type:string;
  governing_standard:string|null;
  material_division:string|null;
  search_tags:string[]|null;
};

const text=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim();

function parentSelect(modal:Element){
  const labels=[...modal.querySelectorAll("label")];
  const label=labels.find(node=>text(node.childNodes[0]?.textContent).toLowerCase().includes("parent wps")||text(node.textContent).toLowerCase().startsWith("parent wps"));
  return label?.querySelector("select") as HTMLSelectElement|null;
}

function isW472Modal(modal:Element){
  const content=text(modal.textContent).toUpperCase();
  return content.includes("CSA W47.2")||content.includes("W47.2");
}

function isW472Wps(record:WpsRecord){
  const tags=(record.search_tags||[]).map(tag=>tag.toUpperCase());
  return tags.includes("W47.2")||record.material_division==="aluminum"||text(record.governing_standard).toUpperCase().includes("W47.2");
}

export default function W47ParentWpsSelector(){
  useEffect(()=>{
    let stopped=false;
    let loading=false;

    const refresh=async()=>{
      if(loading||stopped)return;
      const modal=[...document.querySelectorAll(".modal")].find(node=>text(node.textContent).includes("Upload controlled document"));
      if(!modal||!isW472Modal(modal))return;
      const select=parentSelect(modal);
      if(!select||select.dataset.w472ParentLoaded==="true")return;

      loading=true;
      const {data}=await supabase
        .from("procedures")
        .select("id,document_number,title,document_type,governing_standard,material_division,search_tags")
        .eq("document_type","WPS")
        .order("document_number");
      loading=false;
      if(stopped||!select)return;

      const records=((data||[]) as WpsRecord[]).filter(isW472Wps);
      const existing=new Set([...select.options].map(option=>option.value));
      for(const record of records){
        if(existing.has(record.id))continue;
        const option=document.createElement("option");
        option.value=record.id;
        option.textContent=`${record.document_number}${record.title?` · ${record.title}`:""}`;
        select.appendChild(option);
      }
      select.dataset.w472ParentLoaded="true";
    };

    const observer=new MutationObserver(()=>{
      document.querySelectorAll<HTMLSelectElement>("select[data-w472-parent-loaded='true']").forEach(select=>{
        const modal=select.closest(".modal");
        if(modal&&!isW472Modal(modal))delete select.dataset.w472ParentLoaded;
      });
      void refresh();
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
    void refresh();
    return()=>{stopped=true;observer.disconnect()};
  },[]);
  return null;
}
